module.exports = __webpack_public_path__ + "static/media/ajayShetty.2a6c16c4.jpg";